<template>
  <div style="width: 100%;height: 100%;overflow: auto;">
    <div style="width: 100%;height: 120px;">
      <el-form style="width: 80%;margin: 20px auto auto;">
        <el-row>
          <el-col :span="22">
            <el-form-item label="规则名称：" required>
              <el-input v-model="ruleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效日期：" required>
              <el-date-picker v-model="effectiveDate"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="失效日期：" required>
              <el-date-picker v-model="expiringDate"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div style="width: 100%;height: calc(100% - 160px);">
      <el-tabs type="border-card" style="width: 100%;height: 100%;">
<!----------------------------------SW产品------------------------------------------------>
        <el-tab-pane label="SW产品" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%" always>
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">产品折扣提成：</div>
            <kf-input-table style="width: 700px;margin: auto" component-id="fin_sw_product_discount"
                            v-model="swProductData.product_ratio_list" ref="fin_sw_product_discount"
            ></kf-input-table>
            <!--------------------------------------------------------------------------------------------------------->
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">新客户额外提成：</div>
            <div class="box" style="width: 400px;display: flex;margin: auto">
              <div style="width: 200px;">客户类型</div>
              <div style="width: 200px">额外提成比例(%)</div>
            </div>
            <div style="width: 400px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">正常跟进客户</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.swNormalCustomerCommission" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 400px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">AP方式新客户</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.swApCustomerCommission" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
<!--------------------------------------------------------------------------------------------------------->

            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">反盗版老客户提成扣除：</div>
            <div class="box" style="width: 600px;display: flex;margin: auto">
              <div style="width: 200px;">客户类型</div>
              <div style="width: 200px">扣除比例(%)</div>
              <div style="width: 200px">保底提成比例(%)</div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">U-Leads</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.uDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.uMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">T-Leads</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.tDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.tMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <!--------------------------------------------------------------------------------------------------------->
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">法务类型客户最终提成比例：</div>
            <div class="box" style="width: 600px;display: flex;margin: auto">
              <div style="width: 200px;">客户类型</div>
              <div style="width: 200px">扣除比例(%)</div>
              <div style="width: 200px">保底提成比例(%)</div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">RAID</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.raidDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.raidMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">DE</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.deDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.deMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">CA</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.caDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.caMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">Count</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.countDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.countMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">Audit</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.auditDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.auditMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <div style="width: 600px;display: flex;line-height: 32px;margin: 10px auto auto;">
              <div style="width: 200px;text-align: center;">OS</div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.osDeductionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
              <div style="width: 200px;text-align: center;">
                <el-input-number v-model="swProductData.osMinimumCommissionRatio" precision="1" min="0" max="100"></el-input-number>
              </div>
            </div>
            <!--------------------------------------------------------------------------------------------------------->
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">MRN提成：</div>
            <div style="display: flex;line-height: 32px">
              <div style="margin-left: 200px">MRN提成比例：</div>
              <el-input-number v-model="swProductData.mrnCommissionRatio" style="width: 200px" min="0" max="100" precision="1"></el-input-number>
              <div style="margin-left: 10px">注：以公司到账金额为基数计算</div>
            </div>

            <div style="width: 100%;text-align: center;margin-top: 10px">
              <el-button type="primary" @click="saveSwProductData" style="width: 150px">保存</el-button>
            </div>

          </el-scrollbar>
        </el-tab-pane>
<!----------------------------------技术服务------------------------------------------------>
        <el-tab-pane label="技术服务" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%;" always>
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">技术服务业务提成：</div>
            <kf-input-table style="width: 700px;margin: auto" component-id="fin_technology_service"
                            v-model="technologyServiceData.technology_service_list" ref="fin_technology_service"
            ></kf-input-table>
            <div style="width: 100%;text-align: center;margin-top: 10px">
              <el-button type="primary" @click="saveTechnologyServiceData" style="width: 150px">保存</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
<!----------------------------------其它软件------------------------------------------------>
        <el-tab-pane label="其它软件" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%;" always>
            <div style="display: flex;">
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">其它软件提成：</div>
            <div style="margin-left: 50px;margin-top: 10px;"> 注：以利润为基数计算</div>
            </div>
            <kf-input-table style="width: 700px;margin: auto" component-id="fin_other_software"
                            v-model="otherSoftwareData.other_software_list" ref="fin_other_software"
            ></kf-input-table>
            <div style="width: 100%;text-align: center;margin-top: 10px">
              <el-button type="primary" @click="saveOtherSoftwareData" style="width: 150px">保存</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
<!----------------------------------维护服务------------------------------------------------>
        <el-tab-pane label="维护服务" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%;" always>
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">维护服务提成：</div>
            <kf-input-table style="width: 700px;margin: auto" component-id="fin_sw_product_discount"
                            v-model="maintenanceServiceData.maintenance_service_list" ref="maintenance_product_discount"
            ></kf-input-table>
            <div style="width: 100%;text-align: center;margin-top: 10px">
              <el-button type="primary" @click="saveMaintenanceServiceData" style="width: 150px">保存</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
<!----------------------------------SS维护------------------------------------------------>
        <el-tab-pane label="SS维护" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%;" always>
            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">SS维护服务提成：</div>
            <kf-input-table style="width: 700px;margin: auto" component-id="fin_sw_product_discount"
                            v-model="ssMaintenanceData.ss_maintenance_list" ref="ss_service_product_discount"
            ></kf-input-table>

            <div style="display: flex;line-height: 32px;">
              <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">SS维护提成分配比例：</div>
              <div style="margin-left: 50px;margin-top: 10px;">注：两者比例之和必须为100</div>
            </div>

            <div style="display: flex;line-height: 32px;margin-top: 10px">
              <div style="width: 200px;text-align: right">销售(%)：</div>
              <el-input-number style="width: 200px" v-model="ssMaintenanceData.ssSalesCommission" min="0" max="100" precision="1"></el-input-number>
              <div style="margin-left: 100px">SS专员(%)：</div>
              <el-input-number style="width: 200px" v-model="ssMaintenanceData.ssSsCommissioner" min="0" max="100" precision="1"></el-input-number>
            </div>


            <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">Recapture部分提成：</div>
            <div style="display: flex;line-height: 32px;margin-top: 10px">
              <div style="width: 200px;text-align: right">Recapture提成：</div>
              <el-input-number style="width: 200px" v-model="ssMaintenanceData.recaptureCommission" min="0" max="100" precision="1"></el-input-number>
              <div style="margin-left: 50px">注：以利润为基数计算</div>
            </div>

            <div style="width: 100%;text-align: center;margin-top: 10px">
              <el-button type="primary" @click="saveSsMaintenanceData" style="width: 150px">保存</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
<!----------------------------------回款扣除------------------------------------------------>
        <el-tab-pane label="回款扣除" style="width: 100%;height: 100%;">
          <el-scrollbar style="width: 100%;height: 100%;" always>
          <div style="margin-left: 10px;margin-top: 10px;font-weight: bold">回款超期提成扣除比例：</div>
          <kf-input-table style="width: 700px;margin: auto" component-id="fin_collection_deduction"
                          v-model="collectionDeductionData.collection_deduction_list" ref="fin_collection_deduction"
          ></kf-input-table>
          <div style="width: 100%;text-align: center;margin-top: 10px">
            <el-button type="primary" @click="saveCollectionDeductionData" style="width: 150px">保存</el-button>
          </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
import {nanoid} from "nanoid";

export default {
  name: "CommissionRule",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      objectId:'',
      ruleName:'',
      effectiveDate:'',
      expiringDate:'',
      swProductData: {
        product_ratio_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
        swNormalCustomerCommission: 0,
        swApCustomerCommission: 0,
        uDeductionRatio: 0,
        uMinimumCommissionRatio: 0,
        tDeductionRatio: 0,
        tMinimumCommissionRatio: 0,
        raidDeductionRatio: 0,
        raidMinimumCommissionRatio: 0,
        deDeductionRatio: 0,
        deMinimumCommissionRatio: 0,
        caDeductionRatio: 0,
        caMinimumCommissionRatio: 0,
        countDeductionRatio: 0,
        countMinimumCommissionRatio: 0,
        auditDeductionRatio: 0,
        auditMinimumCommissionRatio: 0,
        osDeductionRatio: 0,
        osMinimumCommissionRatio: 0,
        mrnCommissionRatio:0
      },
      technologyServiceData:{
        technology_service_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
      },
      otherSoftwareData:{
        other_software_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
      },
      maintenanceServiceData:{
        maintenance_service_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
      },
      ssMaintenanceData:{
        ss_maintenance_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
        ssSalesCommission:0,
        ssSsCommissioner:0,
        recaptureCommission:0,
      },
      collectionDeductionData:{
        collection_deduction_list: [{nanoid:nanoid()}, {nanoid:nanoid()},{nanoid:nanoid()}],
      },
      saveSwProduct:false,
      saveTechnologyService:false,
      saveOtherSoftware:false,
      saveMaintenanceService:false,
      saveSsMaintenance:false,
      saveCollectionDeduction:false,
    }
  },


  created() {
    this.initData();
  },
  methods: {
    async saveSwProductData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      let swProductData = this.swProductData;
      let list = [];
      //去除空行
      for (let item of this.swProductData.product_ratio_list) {
        if(item.minimum_discount && item.highest_discount && item.commission_ratio){
          list.push(item);
        }
      }
      swProductData.product_ratio_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        swProductData:swProductData,
      }
      this.objectId = await this.$http('financeService.saveSwProductData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveSwProduct = true;

      await this.checkAllSave();

    },
    async saveTechnologyServiceData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      //去除空行
      let technologyServiceData = this.technologyServiceData;
      let list = [];
      for (let item of this.technologyServiceData.technology_service_list) {
        if(item.business_type && item.minimum_commission_ratio){
          list.push(item);
        }
      }
      technologyServiceData.technology_service_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        technologyServiceData:technologyServiceData,
      }
      this.objectId = await this.$http('financeService.saveTechnologyServiceData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveTechnologyService = true;
      await this.checkAllSave();

    },
    async saveOtherSoftwareData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      //去除空行
      let otherSoftwareData = this.otherSoftwareData;
      let list = [];
      for (let item of this.otherSoftwareData.other_software_list) {
        if(item.minimum_commission_ratio && item.software_name){
          list.push(item);
        }
      }
      otherSoftwareData.other_software_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        otherSoftwareData:otherSoftwareData,
      }
      this.objectId = await this.$http('financeService.saveOtherSoftwareData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveOtherSoftware = true;
      await this.checkAllSave();

    },
    async saveMaintenanceServiceData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      //去除空行
      let maintenanceServiceData = this.maintenanceServiceData;
      let list = [];
      for (let item of this.maintenanceServiceData.maintenance_service_list) {
        if(item.minimum_discount && item.highest_discount && item.commission_ratio){
          list.push(item);
        }
      }
      maintenanceServiceData.maintenance_service_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        maintenanceServiceData:maintenanceServiceData,
      }
      this.objectId = await this.$http('financeService.saveMaintenanceServiceData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveMaintenanceService = true;
      await this.checkAllSave();

    },
    async saveSsMaintenanceData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      //去除空行
      let ssMaintenanceData = this.ssMaintenanceData;
      let list = [];
      for (let item of this.ssMaintenanceData.ss_maintenance_list) {
        if(item.minimum_discount && item.highest_discount && item.commission_ratio){
          list.push(item);
        }
      }
      ssMaintenanceData.ss_maintenance_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        ssMaintenanceData:ssMaintenanceData,
      }
      this.objectId = await this.$http('financeService.saveSsMaintenanceData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveSsMaintenance = true;
      await this.checkAllSave();

    },
    async saveCollectionDeductionData(){
      let check = this.checkRule();
      if(!check){
        return;
      }
      //去除空行
      let collectionDeductionData = this.collectionDeductionData;
      let list = [];
      for (let item of this.collectionDeductionData.collection_deduction_list) {
        if(item.mini_day && item.max_day && item.deduction_ratio_commission){
          list.push(item);
        }
      }
      collectionDeductionData.collection_deduction_list = list;
      let params = {
        objectId:this.objectId,
        ruleName:this.ruleName,
        effectiveDate:this.effectiveDate,
        expiringDate:this.expiringDate,
        collectionDeductionData:collectionDeductionData,
      }
      this.objectId = await this.$http('financeService.saveCollectionDeductionData',params);
      this.$message.success('保存成功');
      this.$fn.search();
      this.saveCollectionDeduction = true;
      await this.checkAllSave();

    },

    async initData(){
      this.objectId = this.parentData.id;
      let data = this.parentData;

      //赋值名称和日期
      this.ruleName = data.name;
      this.effectiveDate = data.effective_date;
      this.expiringDate = data.expiring_date;

      //赋值SW产品
      this.swProductData.product_ratio_list = JSON.parse(data.sw_product_discount);
      this.swProductData.swNormalCustomerCommission = JSON.parse(data.sw_new_customer).swNormalCustomerCommission;
      this.swProductData.swApCustomerCommission = JSON.parse(data.sw_new_customer).swApCustomerCommission;
      this.swProductData.uDeductionRatio = JSON.parse(data.sw_old_customer_piracy).uDeductionRatio;
      this.swProductData.uMinimumCommissionRatio = JSON.parse(data.sw_old_customer_piracy).uMinimumCommissionRatio;
      this.swProductData.tDeductionRatio = JSON.parse(data.sw_old_customer_piracy).tDeductionRatio;
      this.swProductData.tMinimumCommissionRatio = JSON.parse(data.sw_old_customer_piracy).tMinimumCommissionRatio;
      this.swProductData.raidDeductionRatio = JSON.parse(data.sw_legal).raidDeductionRatio;
      this.swProductData.raidMinimumCommissionRatio = JSON.parse(data.sw_legal).raidMinimumCommissionRatio;
      this.swProductData.deDeductionRatio = JSON.parse(data.sw_legal).deDeductionRatio;
      this.swProductData.deMinimumCommissionRatio = JSON.parse(data.sw_legal).deMinimumCommissionRatio;
      this.swProductData.caDeductionRatio = JSON.parse(data.sw_legal).caDeductionRatio;
      this.swProductData.caMinimumCommissionRatio = JSON.parse(data.sw_legal).caMinimumCommissionRatio;
      this.swProductData.countDeductionRatio = JSON.parse(data.sw_legal).countDeductionRatio;
      this.swProductData.countMinimumCommissionRatio = JSON.parse(data.sw_legal).countMinimumCommissionRatio;
      this.swProductData.auditDeductionRatio = JSON.parse(data.sw_legal).auditDeductionRatio;
      this.swProductData.auditMinimumCommissionRatio = JSON.parse(data.sw_legal).auditMinimumCommissionRatio;
      this.swProductData.osDeductionRatio = JSON.parse(data.sw_legal).osDeductionRatio;
      this.swProductData.osMinimumCommissionRatio = JSON.parse(data.sw_legal).osMinimumCommissionRatio;
      this.swProductData.mrnCommissionRatio = JSON.parse(data.sw_mrn).mrnCommissionRatio;

      //赋值技术服务
      this.technologyServiceData.technology_service_list = JSON.parse(data.technology_service);

      //赋值其它软件
      this.otherSoftwareData.other_software_list = JSON.parse(data.other_software);

      //赋值维护服务
      this.maintenanceServiceData.maintenance_service_list = JSON.parse(data.maintenance_service);

      //赋值SS维护服务
      this.ssMaintenanceData.ss_maintenance_list = JSON.parse(data.ss_maintenance_service);
      this.ssMaintenanceData.ssSalesCommission = JSON.parse(data.ss_maintenance_allocation).ssSalesCommission;
      this.ssMaintenanceData.ssSsCommissioner = JSON.parse(data.ss_maintenance_allocation).ssSsCommissioner;
      this.ssMaintenanceData.recaptureCommission = JSON.parse(data.ss_recapture).recaptureCommission;

      //赋值回款扣除
      this.collectionDeductionData.collection_deduction_list = JSON.parse(data.payment_collection);


    },

    checkRule(){
      if(!this.ruleName){
        this.$message.error('请输入规则名称');
        return false;
      }
      if(!this.effectiveDate){
        this.$message.error('请输入生效日期');
        return false;
      }
      if(!this.expiringDate){
        this.$message.error('请输入失效日期');
        return false;
      }
      return true;
    },
    checkAllSave(){
      if(this.saveSwProduct && this.saveTechnologyService && this.saveOtherSoftware
          && this.saveMaintenanceService && this.saveSsMaintenance && this.saveCollectionDeduction){
        this.$fn.closeWindow();
        this.$fn.search();
      }
    }


  },
}
</script>

<style scoped>

.box {
  height: 35px;
  line-height: 35px;
  background-color: #e5e5e5;
  text-align: center;
}

</style>